var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVivaColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "42.6466mm",
    height: "19.7358mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 4265 1974",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_289254712"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D5002C",
    cx: 2319,
    cy: 305,
    r: 305
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDB00",
    cx: 1693,
    cy: 948,
    r: 480
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#002F74",
    cx: 2668,
    cy: 1042,
    r: 389
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 2431,
    cy: 217,
    r: 107
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 1539,
    cy: 1132,
    r: 135
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 2850,
    cy: 1082,
    r: 124
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D5002C",
    fillRule: "nonzero",
    points: "-1,1478 94,1478 215,1822 339,1478 433,1478 259,1961 170,1961 "
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "#D5002C",
    fillRule: "nonzero",
    d: "M501 1458c16,0 29,6 40,17 11,11 17,25 17,41 0,16 -6,29 -17,41 -11,11 -24,17 -40,17 -16,0 -29,-6 -41,-17 -11,-11 -17,-25 -17,-42 0,-16 6,-29 17,-40 11,-11 25,-17 40,-17zm-45 147l89 0 0 357 -89 0 0 -357z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 2,
    fill: "#D5002C",
    fillRule: "nonzero",
    points: "556,1604 648,1604 738,1815 828,1604 919,1604 766,1961 709,1961 "
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "#D5002C",
    fillRule: "nonzero",
    d: "M1203 1604l89 0 0 357 -89 0 0 -38c-17,17 -35,28 -53,36 -18,7 -37,11 -57,11 -46,0 -86,-18 -120,-54 -34,-36 -51,-80 -51,-133 0,-55 16,-100 49,-135 33,-35 72,-53 119,-53 22,0 42,4 60,12 19,8 36,20 52,36l0 -39zm-94 73c-28,0 -51,10 -69,29 -18,20 -28,45 -28,75 0,31 9,56 28,76 19,20 42,30 69,30 28,0 52,-10 70,-29 19,-20 28,-45 28,-77 0,-31 -9,-56 -28,-75 -19,-19 -42,-29 -70,-29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M1805 1563l-64 61c-44,-46 -93,-69 -148,-69 -46,0 -85,16 -117,47 -32,32 -48,70 -48,116 0,32 7,61 21,86 14,25 34,45 59,59 26,14 54,21 86,21 27,0 51,-5 73,-15 22,-10 47,-28 73,-54l62 65c-36,35 -69,59 -101,73 -32,14 -68,20 -109,20 -75,0 -137,-24 -185,-71 -48,-48 -72,-109 -72,-183 0,-48 11,-91 33,-128 22,-37 53,-67 94,-90 41,-23 84,-34 131,-34 40,0 78,8 115,25 37,17 69,41 95,72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M2011 1596c34,0 65,8 95,25 30,17 53,40 70,68 17,29 25,60 25,93 0,34 -8,65 -25,94 -17,29 -40,52 -69,69 -29,16 -61,25 -96,25 -51,0 -95,-18 -131,-54 -36,-36 -54,-81 -54,-133 0,-56 21,-102 62,-139 36,-32 77,-48 124,-48zm1 84c-28,0 -51,10 -70,29 -19,19 -28,44 -28,74 0,31 9,56 27,75 18,19 41,29 70,29 28,0 51,-10 70,-29 19,-19 28,-44 28,-75 0,-31 -9,-55 -27,-75 -18,-19 -42,-29 -70,-29z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 6,
    fill: "#002F74",
    fillRule: "nonzero",
    points: "2233,1466 2322,1466 2322,1961 2233,1961 "
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M2539 1596c34,0 65,8 95,25 30,17 53,40 70,68 17,29 25,60 25,93 0,34 -8,65 -25,94 -17,29 -40,52 -69,69 -29,16 -61,25 -96,25 -51,0 -95,-18 -131,-54 -36,-36 -54,-81 -54,-133 0,-56 21,-102 62,-139 36,-32 77,-48 124,-48zm1 84c-28,0 -51,10 -70,29 -19,19 -28,44 -28,74 0,31 9,56 27,75 18,19 41,29 70,29 28,0 51,-10 70,-29 19,-19 28,-44 28,-75 0,-31 -9,-55 -27,-75 -18,-19 -42,-29 -70,-29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M2769 1604l89 0 0 42c15,-17 32,-30 51,-38 19,-8 39,-13 61,-13 22,0 43,5 61,16 18,11 33,27 43,48 14,-21 32,-37 52,-48 21,-11 43,-16 68,-16 25,0 48,6 67,18 19,12 33,27 42,46 8,19 13,50 13,93l0 209 -89 0 0 -180c0,-40 -5,-68 -15,-82 -10,-14 -26,-21 -46,-21 -16,0 -29,4 -42,13 -12,9 -22,21 -27,36 -6,15 -9,40 -9,74l0 161 -89 0 0 -172c0,-32 -2,-55 -7,-69 -5,-14 -12,-25 -21,-32 -10,-7 -21,-10 -35,-10 -15,0 -29,4 -41,13 -12,9 -21,21 -28,37 -6,16 -9,41 -9,75l0 158 -89 0 0 -357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M3460 1466l0 177c16,-16 34,-28 52,-36 19,-8 39,-12 60,-12 47,0 86,18 119,53 33,35 49,80 49,135 0,53 -17,97 -51,133 -34,36 -74,54 -120,54 -21,0 -40,-4 -57,-11 -18,-7 -35,-19 -53,-36l0 38 -89 0 0 -495 89 0zm94 211c-28,0 -52,10 -70,29 -19,19 -28,44 -28,75 0,32 9,57 28,77 19,20 42,29 70,29 27,0 50,-10 69,-30 19,-20 28,-45 28,-76 0,-31 -9,-56 -28,-75 -18,-20 -41,-29 -70,-29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M3818 1458c16,0 29,6 40,17 11,11 17,25 17,41 0,16 -6,29 -17,41 -11,11 -24,17 -40,17 -16,0 -29,-6 -41,-17 -11,-11 -17,-25 -17,-42 0,-16 6,-29 17,-40 11,-11 25,-17 40,-17zm-45 147l89 0 0 357 -89 0 0 -357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 11,
    fill: "#002F74",
    fillRule: "nonzero",
    d: "M4176 1604l89 0 0 357 -89 0 0 -38c-17,17 -35,28 -53,36 -18,7 -37,11 -57,11 -46,0 -86,-18 -120,-54 -34,-36 -51,-80 -51,-133 0,-55 16,-100 49,-135 33,-35 72,-53 119,-53 22,0 42,4 60,12 19,8 36,20 52,36l0 -39zm-94 73c-28,0 -51,10 -69,29 -18,20 -28,45 -28,75 0,31 9,56 28,76 19,20 42,30 69,30 28,0 52,-10 70,-29 19,-20 28,-45 28,-77 0,-31 -9,-56 -28,-75 -19,-19 -42,-29 -70,-29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivaColombia);
export default __webpack_public_path__ + "static/media/Viva Colombia.902dfb5b7b5e772c31eed868b64bc55b.svg";
export { ForwardRef as ReactComponent };